import { html, defineElement, TemplateElement, i18n } from '@webtides/element-js';

class ProductAvailability extends TemplateElement {
    constructor() {
        super({ shadowRender: false });
    }

    properties() {
        return {
            availabilities: [],
            showAvailabilitySearch: false,
        };
    }

    getColorFromStatus(status) {
        switch (status) {
            case 'GREEN':
                return 'text-status-green';
            case 'ORANGE':
                return 'text-status-orange';
            case 'RED':
                return 'text-status-red';
            case 'BLUE':
                return 'text-status-blue';
        }
    }

    getIconFromType(type) {
        switch (type) {
            case 'DELIVERY':
                return 'indicator_dhl';
            case 'PIN':
                return 'indicator_pickup';
            case 'DOT':
                return 'indicator_delivery';
            case 'INFO':
                return 'indicator_soon';
        }
    }

    getIconClassFromType(type) {
        switch (type) {
            case 'DELIVERY':
                return 'w-6 h-6';
            case 'PIN':
                return 'w-6 h-6';
            case 'DOT':
                return 'w-2 h-2';
            case 'INFO':
                return 'w-5 h-5';
        }
    }

    templateAvailabilitySearch() {
        return html`
            <modal-trigger target-modal="availability-search-modal" class="inline-block">
                <button class="max-w-full text-sm truncate text-left underline">
                    <span> ${i18n('cta.retailerAvailabilitySearch.label', 'Verfügbarkeit beim Händler prüfen')} </span>
                </button>
            </modal-trigger>
        `;
    }

    templateStoreInformationTrigger(stores) {
        return html`
            ${stores.map((store, index) => {
                return html`
                    <modal-trigger target-modal="${store.modalId}" class="inline-block">
                        <button class="max-w-full text-sm truncate text-left underline">
                            <span> ${store.label}${index < stores.length - 1 ? ',' : ''}</span>
                        </button> </modal-trigger>
                `;
            })}
        `;
    }

    template() {
        return html`
            <div class="space-y-2">
                ${this.availabilities.map(({ icon, title, text, stores }, index) => {
                    return html`
                        <div class="flex items-center text-sm">
                            <div class="w-10 h-10 flex flex-shrink-0 items-center justify-center">
                                <svg-icon
                                    name="${this.getIconFromType(icon.type)}"
                                    class="block ${this.getColorFromStatus(icon.status)} ${this.getIconClassFromType(
                                        icon.type
                                    )}"
                                ></svg-icon>
                            </div>
                            <div>
                                <div class="font-bold text-grey-700 leading-tight">
                                    ${title} &nbsp;
                                    ${index === 1 && this.showAvailabilitySearch
                                        ? this.templateAvailabilitySearch()
                                        : ''}
                                </div>
                                <div class="text-grey-600 leading-tight">
                                    ${text} ${stores ? this.templateStoreInformationTrigger(stores) : ''}
                                </div>
                            </div>
                        </div>
                    `;
                })}
            </div>
        `;
    }
}

defineElement('product-availability', ProductAvailability);
